import 'core-js';
import 'focus-visible';
import React from 'react';
import { createRoot } from 'react-dom/client';
import initI18Next from './i18n';
import App from './root/app/app';
import * as serviceWorker from './serviceWorker';

function init() {
	const app = document.getElementById('app');

	if (app !== null) {
		const page = JSON.parse(app.getAttribute('data-page'));
		const navigation = JSON.parse(app.getAttribute('data-navigation'));
		const settings = JSON.parse(app.getAttribute('data-settings'));
		const appFrame = JSON.parse(app.getAttribute('data-appframe'));
		const language = app.getAttribute('data-lang');
		initI18Next(language);

		app.removeAttribute('data-page');
		app.removeAttribute('data-navigation');
		app.removeAttribute('data-settings');
		app.removeAttribute('data-appframe');
		const root = createRoot(app);
		root.render(<App page={page} navigation={navigation} settings={settings} appFrame={appFrame} />);
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
